import { render, staticRenderFns } from "./SchoolHistoryTable.vue?vue&type=template&id=49abb99b"
import script from "./SchoolHistoryTable.vue?vue&type=script&lang=js"
export * from "./SchoolHistoryTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports